import type { Editor } from "@tiptap/core";
import type { Range } from "@tiptap/core";

export type MediaLinkType = "youtube" | "twitter";

type OpenMediaLinkModalFn = (
  editor: Editor,
  range: Range,
  type: MediaLinkType,
  position?: { top: number; left: number }
) => void;

let openMediaLinkModalFn: OpenMediaLinkModalFn | null = null;

export function setOpenMediaLinkModal(fn: OpenMediaLinkModalFn | null) {
  openMediaLinkModalFn = fn;
}

export function openMediaLinkModal(
  editor: Editor,
  range: Range,
  type: MediaLinkType,
  position?: { top: number; left: number }
) {
  if (openMediaLinkModalFn) {
    openMediaLinkModalFn(editor, range, type, position);
  }
}
